import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import styles from "./styles.module.scss";
const HelpText = (props) => (_jsx("div", { className: styles.help_container, children: _jsx("span", { children: props.helpText }) }));
export default memo(HelpText);
